<template>
<div class="acd-wrap">
	<!-- label v-bind:class="[specialNavi.show ? 'level1 is-open' : 'level1']" v-on:click="toggleList(specialNavi)">特集から探す</label>
  <transition>
  <div v-show="specialNavi.show">
	<ul class="sub-nav__catalog-special">
		<li><router-link :to="{name: 'catlist', params: {Name: '新'}}">新入荷商品</router-link></li>
		<li><router-link :to="{name: 'catlist', params: {Name: 'おすすめ'}}">おすすめ商品</router-link></li>
		<li><router-link :to="{name: 'catlist', params: {Name: '災害'}}">災害支援商品</router-link></li>
	</ul>
  </div>
  </transition -->
	<div v-bind:class="[mainNavi.show ? 'side_ttl' : 'side_ttl acd-ttl']" v-on:click="toggleList(mainNavi)"><p>機種一覧から探す</p></div>
	<transition>
	<div v-if="mainNavi.show">
    <div v-for="category in sortCategories" v-bind:key="category.id">
      <ul class="acd-menu">
        <li>
          <p v-bind:class="[category.show ? 'acd-menu-ttl' : 'acd-menu-ttl']" v-on:click="toggleListInMainNavi(category, sortCategories)">
            {{category.name}}
          </p>
        </li>
        <transition>
        <li v-if="category.show">
          <ul class="acd-menu01">
            <li v-for="child in category.child" v-bind:key="child.id">
              <p v-if="child.child.length > 0" v-bind:class="[child.show ? 'acd-menu01-ttl' : 'acd-menu01-ttl']" v-on:click="toggleListInMainNavi(child, category.child)">
                  {{child.name}}
              </p>
              <ul v-else>
                <ul class="acd-menu02">
                  <li>
                    <router-link :to="{ name: 'list', params: {Id: child.id}}">{{child.name}}</router-link>
                  </li>
                </ul>
              </ul>
              <transition>
              <ul v-if="child.show" class="acd-menu02">
                  <li v-for="childone in child.child" v-bind:key="childone.id">
                    <router-link :to="{ name: 'list', params: {Id: childone.id}}">{{childone.name}}</router-link>
                  </li>
              </ul>
              </transition>
            </li>
          </ul>
        </li>
        </transition>
      </ul>
    </div>
  </div>
  </transition>
	<div v-bind:class="[docsNavi.show ? 'side_ttl' : 'side_ttl acd-ttl02']" v-on:click="toggleList(docsNavi)"><p>参考資料</p></div>
  <transition>
    <div v-show="docsNavi.show">
      <div v-html="docsHtml"></div>
    </div>
	</transition>
</div>
</template>

<script>	
  export default {
    data: function () {
      return {
				specialNavi: {
					show: false
				},
				mainNavi: {
					show: false
				},
				docsNavi: {
					show: false
				},
        sortCategories: [], //categories
        docsHtml: ''
      }
    },
    props: {
      categorySet: {
        type: Array,
        require: true
      }
    },
    mounted () {
      this.sortCategories = this.categorySet
      var baseUrl = process.env.BASE_URL || '/'
      fetch(baseUrl + 'parts/side_docs.html')
        .then(function (res) {
          if (!res.ok) {
            throw new Error('side_docs.html load failed: ' + res.status)
          }
          return res.text()
        })
        .then(function (html) {
          this.docsHtml = html
        }.bind(this))
        .catch(function (e) {
          console.error(e)
        })
    },
    methods: {
      toggleList: function (menu){
        menu.show = !menu.show
      },
      toggleListInMainNavi: function (menu, uppermenus = []){
        if (menu.show) {
          menu.show = false
          return
        }
        for(var i=0;i<uppermenus.length;i++){
          uppermenus[i].show = false
        }
        menu.show = true
      },
    },
    watch: {
      categorySet(newSet){
        this.sortCategories = newSet
      }
    }
  }
</script>
